// styles
import styles from "components/molecules/StepContainer/StepContainer.module.css";

export type OptionalType = true | false;
export type ActiveType = true | false;

type StepContainerProps = {
	step: number;
	subHeader: string;
	optional?: OptionalType;
	active?: ActiveType;
	noMaxWidth?: boolean;
	showRequiredForSubHeader?: boolean;
};

const StepContainer = ({ step, subHeader, optional = false, active = true, noMaxWidth, showRequiredForSubHeader }: StepContainerProps) => {
	const headerClassName = active ? styles.header_active : styles.header_inactive;
	return (
		<div className={noMaxWidth ? "" : "w-max"}>
			{optional ? <h1 className={headerClassName}>Step {step} (Optional)</h1> : <h1 className={headerClassName}>Step {step}</h1>}
			<h2 className={active ? styles.subHeader_active : styles.subHeader_inactive}>
				{subHeader}
				{showRequiredForSubHeader && <span className="text-red-500">*</span>}
			</h2>
		</div>
	);
};

export default StepContainer;
